export const messages = {
    "wrh-dashboard.nav-menu.item.resources": "リソース",
    "wrh-dashboard.nav-menu.item.shared": "共有",
    "wrh-dashboard.nav-menu.item.backups": "バックアップ",
    "wrh-dashboard.nav-menu.item.archives": "アーカイブ",
    "wrh-dashboard.nav-menu.item.sync": "同期",
    "wrh-dashboard.nav-menu.item.mobile": "携帯電話",
    "wrh-dashboard.nav-menu.item.account": "アカウント",
    "wrh-dashboard.search.input.hint": "検索",
    "wrh-dashboard.search.label.breadcrumb": "検索結果",
    "wrh-dashboard.search.message.empty": "検索に一致する項目はありません",
    "wrh-dashboard.side-bar.selected.title:plural": "{count}アイテム選択済み | {count}アイテム選択済み",
    "wrh-dashboard.side-bar.backup-type.entire-pc": "コンピュータ全体",
    "wrh-dashboard.side-bar.backup-type.entire-mac": "Mac全体",
    "wrh-dashboard.side-bar.backup-type.disk": "ディスクとパーティション",
    "wrh-dashboard.side-bar.backup-type.file": "ファイルとフォルダ",
    "wrh-dashboard.side-bar.backup-type.notarized": "公証済みのファイルとフォルダ",
    "wrh-dashboard.side-bar.backup-type.sync": "同期",
    "wrh-dashboard.side-bar.backup-type.archiving": "アーカイブ",
    "wrh-dashboard.space-indicator.label.left": "残り{spaceFree}",
    "wrh-dashboard.space-indicator.label.used": "{usedSpace} 使用",
    "wrh-dashboard.space-indicator.label.unlimited": "無制限",
    "wrh-dashboard.backups-table.column.name": "名前",
    "wrh-dashboard.backups-table.column.size": "サイズ",
    "wrh-dashboard.backups-table.column.version": "最新バージョン",
    "wrh-dashboard.backups-table.action.cleanup": "クリーンアップ",
    "wrh-dashboard.backups-table.action.delete": "削除",
    "wrh-dashboard.backups-table.message.no-backups": "クラウドにはまだバックアップがありません",
    "wrh-dashboard.backups-table.message.no-archives": "クラウドにはまだアーカイブがありません",
    "wrh-dashboard.backups-table.message.no-syncs": "クラウドにはまだ同期がありません",
    "wrh-dashboard.backups-sidebar.label.size": "サイズ",
    "wrh-dashboard.backups-sidebar.label.type": "タイプ",
    "wrh-dashboard.backups-sidebar.label.version": "最新バージョン",
    "wrh-dashboard.content-table.column.name": "名前",
    "wrh-dashboard.content-table.column.versions": "バージョン",
    "wrh-dashboard.content-table.column.volumes": "ボリューム",
    "wrh-dashboard.content-table.column.path": "パス",
    "wrh-dashboard.content-table.column.size": "サイズ",
    "wrh-dashboard.content-table.column.version": "最新バージョン",
    "wrh-dashboard.content-table.action.notary-verify": "ベリファイ",
    "wrh-dashboard.content-table.action.notary-get-crt": "証明書の取得",
    "wrh-dashboard.content-table.action.asign": "署名のために送信",
    "wrh-dashboard.content-table.action.versions": "バージョン",
    "wrh-dashboard.content-table.action.restore": "ダウンロード",
    "wrh-dashboard.content-table.action.share": "リンクの共有",
    "wrh-dashboard.content-table.label.size": "サイズ",
    "wrh-dashboard.content-table.label.created": "作成",
    "wrh-dashboard.content-table.label.modified": "変更日",
    "wrh-dashboard.content-table.message.empty-folder": "このフォルダは空です",
    "wrh-dashboard.password-dialog-box.title.backup": "暗号化されたバックアップ",
    "wrh-dashboard.password-dialog-box.title.archive": "暗号化されたアーカイブ",
    "wrh-dashboard.password-dialog-box.message.backup": "バックアップ{displayName}にアクセスするためのパスワードを指定してください",
    "wrh-dashboard.password-dialog-box.message.archive": "アーカイブ{displayName}にアクセスするためのパスワードを指定してください",
    "wrh-dashboard.password-dialog-box.hint.password": "パスワード",
    "wrh-dashboard.password-dialog-box.message.invalid-password": "パスワードが正しくありません",
    "wrh-dashboard.form.button.open": "開く",
    "wrh-dashboard.form.button.close": "閉じる",
    "wrh-dashboard.form.button.cancel": "キャンセル",
    "wrh-dashboard.form.button.continue": "続行",
    "wrh-dashboard.form.button.proceed": "続行",
    "wrh-dashboard.form.button.delete": "削除",
    "wrh-dashboard.form.button.done": "完了",
    "wrh-dashboard.form.button.retry": "再試行",
    "wrh-dashboard.form.button.go-to-backups": "[バックアップ] に移動",
    "wrh-dashboard.delete-dialog-box.title.backup": "バックアップの削除",
    "wrh-dashboard.delete-dialog-box.message.backup": "選択したバックアップをすべてのロケーションから完全に削除してもよろしいですか？バックアップのすべてのデータは破棄され、復元できなくなります。",
    "wrh-dashboard.delete-dialog-box.title.archive": "アーカイブの削除",
    "wrh-dashboard.delete-dialog-box.message.archive": "選択したアーカイブをすべてのロケーションから完全に削除してもよろしいですか？アーカイブのすべてのデータは破棄され、復元できなくなります。",
    "wrh-dashboard.cleanup-dialog-box.title": "{brandName}のクリーンアップ",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-versions-older-than": "以下より古いバックアップのバージョンは削除する",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-except": "以下を除く古いバックアップのバージョンはすべて削除する",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-recent-ones": "バージョン以外のバージョンをすべて削除",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.days": "日",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.months": "月",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.years": "年",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup-now": "今すぐクリーンアップ",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup": "クリーンアップ",
    "wrh-dashboard.cleanup-dialog-box.message": "{brandName}で非継続的に古いバックアップのバージョンを削除して、領域を解放できます。これにより、True Image内のバックアップに設定されたクリーンアップ設定が変更されることはありません。",
    "wrh-dashboard.cleanup-dialog-box.message.cleanup-encrypted": "{encryptedBackupCount}/{totalBackupCount}のバックアップが暗号化されています。クリーンアップするには、パスワードを入力する必要があります。個別にクリーンアップしてください。",
    "wrh-dashboard.cleanup-confirm-dialog-box.title": "クリーンアップ",
    "wrh-dashboard.cleanup-confirm-dialog-box.message": "このデータを削除してもよろしいですか？この操作は元に戻せません。",
    "wrh-dashboard.cleanup-encrypted-dialog-box.title": "{brandName}のクリーンアップ",
    "wrh-dashboard.cleanup-encrypted-dialog-box.message": "バックアップの暗号化のみを行いました。クリーンアップするには、パスワードを入力する必要があります。個別にクリーンアップしてください。",
    "wrh-dashboard.cleanup-progress-dialog-box.title": "クリーンアップ",
    "wrh-dashboard.cleanup-progress-dialog-box.message": "クリーンアップ操作のステータスを表示するには、このウィンドウを開いたままにします。ウィンドウを閉じると、クリーンアップ操作はバックグラウンドモードで継続します。",
    "wrh-dashboard.cleanup-progress-dialog-box.status": "{displayName}はクリーンアップ中です...",
    "wrh-dashboard.cleanup-notification-dialog-box.title": "クリーンアップ",
    "wrh-dashboard.cleanup-notification-dialog-box.message.success": "クリーンアップが正常に終了しました。クラウド使用状況に関する情報のアップデートには、時間がかかることがあります。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.fail": "クリーンアップが失敗しました",
    "wrh-dashboard.cleanup-notification-dialog-box.message.box-locked": "バックアップの進行中は、クリーンアップを実行できません。後でもう一度お試しください。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.wait": "クリーンアップはバックグラウンドモードで引き続き実行中です。クリーンアップが終了するまでお待ちください。",
    "wrh-dashboard.shared-content-table.column.name": "名前",
    "wrh-dashboard.shared-content-table.column.location": "ロケーション",
    "wrh-dashboard.shared-content-table.column.source": "ソース",
    "wrh-dashboard.shared-content-table.column.days": "日",
    "wrh-dashboard.shared-content-table.column.downloads": "ダウンロード",
    "wrh-dashboard.shared-content-table.column.shared": "共有場所",
    "wrh-dashboard.shared-content-table.label.shared": "共有場所",
    "wrh-dashboard.shared-content-table.label.backup": "ソース",
    "wrh-dashboard.shared-content-table.action.share": "リンクの共有",
    "wrh-dashboard.shared-content-table.action.settings": "リンクの設定",
    "wrh-dashboard.shared-content-table.action.delete": "リンクの削除",
    "wrh-dashboard.shared-content-table.action.delete-selected": "リンクの削除",
    "wrh-dashboard.account-page.message.used-space": "{brandName}: {spaceFree}/{totalSpace}の空き領域",
    "wrh-dashboard.account-page.message.used-unlimited-space": "{brandName}:無制限の領域",
    "wrh-dashboard.account-page.button.sign-out": "サインアウト",
    "wrh-dashboard.account-page.button.clean-up": "クリーンアップ",
    "wrh-dashboard.account-page.button.manage-subscription": "ライセンスの管理",
    "wrh-dashboard.account-page.message.subscription.active": "{brandName}の領域のライセンスの有効期限",
    "wrh-dashboard.account-page.message.subscription.trial": "{brandName}のトライアル版の有効期限",
    "wrh-dashboard.account-page.message.subscription.expired": "{brandName}の領域のライセンスの有効期限",
    "wrh-dashboard.account-page.message.worm-status.storage-full": "{brandName}のストレージに空き領域がありません。データをクラウドにバックアップまたはアーカイブできません。",
    "wrh-dashboard.account-page.message.worm-status.less-than": "空き領域は{percent}パーセント未満です。{brandName}は間もなく使用できなくなります。",
    "wrh-dashboard.notary.verify.view.status.downloading": "ダウンロードしています...",
    "wrh-dashboard.notary.verify.view.status.validating": "ベリファイしています...",
    "wrh-dashboard.notary.verify.view.status.pending": "証明書を保留にしています...",
    "wrh-dashboard.notary.verify.view.status.fail": "証明書の不一致...",
    "wrh-dashboard.notary.verify.view.button.get-crt": "証明書の取得",
    "wrh-dashboard.notary.verify.view.file-info.name": "名前",
    "wrh-dashboard.notary.verify.view.file-info.signed-by": "署名者",
    "wrh-dashboard.notary.verify.view.file-info.date-backed-up": "日付をバックアップ済み",
    "wrh-dashboard.notary.verify.view.file-info.date-notarized": "日付を公証済み",
    "wrh-dashboard.notary.verify.view.button.cancel": "キャンセル",
    "wrh-dashboard.notary.verify.view.button.done": "完了",
    "wrh-dashboard.notary.warning.unsupported.browser.version": "サポートされていないブラウザのバージョン",
    "wrh-dashboard.versions-dialog-box.title": "{fileName}のバージョン",
    "wrh-dashboard.asign-dialog-box.title": "署名のために送信",
    "wrh-dashboard.asign-dialog-box.message": "ファイルのバージョンは共有されていますが、そのバージョンへのリンクがなければファイルを表示できません。ASignに進み、署名を追加し、リンクを共有します。",
    "wrh-dashboard.asign-dialog-box.button.show-signed-file-details": "ファイルの詳細情報の表示",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.copy": "リンクのコピー",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.manage": "リンクの設定",
    "wrh-dashboard.shared-link-dialog-box.share-view.message": "このリンクを使用して誰でもデータの最新バージョンを表示できます。",
    "wrh-dashboard.shared-link-dialog-box.share-view.label.shared": "{creationDate}に共有",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "リンクをコピー済み",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "リンクのコピーエラー",
    "wrh-dashboard.shared-link-dialog-box.delete-view.title": "リンクの削除",
    "wrh-dashboard.shared-link-dialog-box.delete-view.message": "このリンクは、すべてのユーザーに対して無効になります。",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.title": "リンクの削除",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.message": "これらのリンクは、すべてのユーザーに対して無効になります",
    "wrh-dashboard.shared-link-dialog-box.manage-view.title": "リンクの設定",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.delete": "リンクの削除",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.apply": "完了",
    "wrh-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "パスワード",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "パスワードをリセット",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "パスワードによる保護",
    "wrh-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "パスワードを使用してこのリンクを保護",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "有効期限",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "ダウンロードの制限",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "{splitMarker}日でこのリンクを無効にする | {splitMarker}日でこのリンクを無効にする",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "{splitMarker}回のダウンロード後にこのリンクを無効にする | {splitMarker}回のダウンロード後にこのリンクを無効にする",
    "wrh-dashboard.page-not-found.title": "ページが見つかりません",
    "wrh-dashboard.page-not-found.message.main": "お探しのページが見つかりませんでした。",
    "wrh-dashboard.page-not-found.message.description": "リンクが古いか、アドレスが正しく入力されなかった可能性があります。",
    "wrh-dashboard.page-not-found.message.error": "エラー コード:404",
    "wrh-dashboard.server-error.title": "サーバーを利用できません",
    "wrh-dashboard.server-error.message": "サーバーは現在使用できません。後でもう一度お試しください。",
    "wrh-dashboard.server-error.message.error": "エラー コード:500"
};
